import { useEffect, useState } from 'react';
/**
 * This hook enables/disables the overscroll behavior globally. Note that this is not supported on Safari,
 * so we may need to implement a fallback solution if support there is requred.
 * See: https://caniuse.com/css-overscroll-behavior
 * @param config Used to enable or disable the overscroll behavior dynamically
 */
export default function useDisableSwipe() {
    const [disableSwipeConfig, setDisableSwipeConfig] = useState();
    const handleConfigUpdate = () => {
        /** Apply effect if no config is provided or config with inactive flag is false */
        if (disableSwipeConfig?.inactive) {
            return () => { };
        }
        // @ts-expect-error
        document.body.style.overscrollBehavior = disableSwipeConfig?.inactive ? 'unset' : 'none';
        return () => {
            // @ts-expect-error
            document.body.style.overscrollBehavior = 'unset';
        };
    };
    useEffect(handleConfigUpdate, [disableSwipeConfig?.inactive]);
    return { disableSwipeConfig, setDisableSwipeConfig };
}
//# sourceMappingURL=useDisableSwipe.web.js.map